import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

/** Page reset every preview frame renders its content under. */
export const FRAME_RESET_CSS =
  "html, body {padding:0;margin:0;overflow:hidden;} div {box-sizing:border-box}";

const ThemeStyleFrame = ({ children, id, ignoreHeight }) => {
  const [contentRef, setContentRef] = useState(null);
  const [height, setHeight] = useState(1);
  const mountNode = contentRef?.contentWindow?.document?.body;

  const setNewHeight = () => {
    const refHeight = contentRef?.contentWindow?.document?.body?.children[0]?.clientHeight;
    if (refHeight) {
      setHeight(refHeight);
    }
  };

  useEffect(setNewHeight, [contentRef, children]);

  // Widget upgrades and font loads change the content's height without a re-render.
  useEffect(() => {
    const content = mountNode?.children[0];
    const FrameResizeObserver = contentRef?.contentWindow?.ResizeObserver;
    if (ignoreHeight || !content || !FrameResizeObserver) return undefined;

    const observer = new FrameResizeObserver(setNewHeight);
    observer.observe(content);
    return () => observer.disconnect();
  }, [contentRef, mountNode, ignoreHeight]);

  const frameStyle = {
    ...(ignoreHeight ? {} : { height }),
    width: "100%",
    display: "block",
  };

  const frameProps = {
    id,
    frameBorder: 0,
    style: frameStyle,
    pointerEvents: "auto",
  };

  return (
    <iframe title={id} ref={setContentRef} {...frameProps}>
      {mountNode && createPortal(children, mountNode)}
    </iframe>
  );
};

export default ThemeStyleFrame;
